import { Injectable } from '@angular/core';
import { JeevesCustomerListConfigService } from 'gung-standard-jeeves';
import { CarLinerCustomerListCardComponent } from '../components/car-liner-customer-list-card/car-liner-customer-list-card.component';
import { ConfigBaseFilter, ListLayout, ListLayoutSingleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { Customer, MetadataService } from 'gung-standard';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export class CustomerCategoryFilter extends SimpleConfigBaseFilter<Customer> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'CUSTOMER_CATEGORY';
  }
  getOptionIds(item: Customer): string[] {
    const metadataValue = this.metadataService.getMetadataValue('x1k', 'kundkatbeskr', item.extra.kus.kundkategorikod);
    if (metadataValue == null) {
      return [];
    } else {
      return [metadataValue];
    }
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class CustomerINACTIVEFilter extends SimpleConfigBaseFilter<Customer> {

  getName(): string {
    return 'INACTIVE';
  }
  getOptionIds(item: Customer): string[] {
    return [item.extra.kus.makulerad === '1' ? 'YES' : 'NO'];
  }

  getOptionName(key: string): string {
    return key;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CarLinerCustomerListConfigService extends JeevesCustomerListConfigService {

  getLayouts(): ListLayout<Customer>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerCustomerListCardComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Customer list'
      }
    ];
  }

  getFilters(): ConfigBaseFilter<Customer>[] {
    const filters = super.getFilters();

    filters.push(new CustomerCategoryFilter(this.metadataService));
    filters.push(new CustomerINACTIVEFilter());

    return filters;
  }

  getItems(): Observable<Customer[]> {
    return super.getItems().pipe(
      map(customers => {
        return customers.filter(customer => {
          switch (customer.extra.kus.kundkategorikod) {
            case 11:
            case 13:
            case 16:
              return environment.projectName === 'caroliner';
            case 12:
              return environment.projectName === 'blackhawk';
            case 14:
            case 17:
              return environment.projectName === 'josam';
            case 0:
            case 5:
            case 6:
              return environment.projectName === 'thailand';
            default:
              return false;
          }
        });
      })
    )
  }
}
